'use strict';

var _ = require('lodash');
var HostLadderListController = function HostLadderListController($scope, recommendationFilterService, mapHostLadderService) {
  var applicableDateLabels = [{
    field: 'tripType',
    label: ''
  }, {
    field: 'fareBrandName',
    label: ' '
  }, {
    field: 'season',
    label: 'Season'
  }, {
    field: 'dow',
    label: 'DOW'
  }, {
    field: 'ap',
    label: 'AP'
  }, {
    field: 'mms',
    label: 'MMS'
  }, {
    field: 'currencyCode',
    label: 'Currency'
  }];
  var currencyCode;
  $scope.$watch('screenState.recommendationDetailsPanel.contextData', function () {
    var contextData = $scope.screenState.recommendationDetailsPanel.contextData;
    if (contextData && !_.isEmpty(contextData)) {
      if (!$scope.screenState.recommendationDetailsPanel.chartDataAvailable) {
        $scope.screenState.recommendationDetailsPanel.ladderGroupChartDataList = getLadderGroupChartData(contextData);
        $scope.screenState.recommendationDetailsPanel.chartDataAvailable = true;
        mapHostLadderService.initialize($scope.screenState.recommendationDetailsPanel.ladderGroupChartDataList);
      }
      var groupedFaresArray = groupCurrentAndRecommendedTotalFares(contextData);
      $scope.settings = {
        fareRange: [Math.round(_.min(groupedFaresArray)), Math.round(_.max(groupedFaresArray))]
      };
      $scope.$broadcast('hostViewFilter');
    }
  });
  $scope.$watchCollection('screenState.recommendationDetailsPanel.ladderGroupChartDataList', function () {
    $scope.screenState.recommendationDetailsPanel.selectedHostLadder = $scope.screenState.recommendationDetailsPanel.ladderGroupChartDataList[0];
  });
  function groupCurrentAndRecommendedTotalFares(contextData) {
    return _.flatMap(_.chain(contextData.fareLaddersInGroup).map(function (fareLadder) {
      return _.chain(fareLadder.groupedRows).filter(isNonLinkedFbc).filter(isNonDualRbdFare).map(function (row) {
        return [row.currentFareTotal, row.effectiveTotalFare];
      }).value();
    }).flatten().value());
  }
  function isNonLinkedFbc(row) {
    return _.isNil(row.isLinkedFbc) || row.isLinkedFbc === false;
  }
  function isNonDualRbdFare(row) {
    return _.isNil(row.isDualRbdFare) || row.isDualRbdFare === false;
  }
  function getLadderGroupChartData(contextData) {
    return _.reduce(contextData.fareLaddersInGroup, function (ladderGroupChartDataList, entry) {
      currencyCode = entry.groupedRows[0].currencyCode;
      ladderGroupChartDataList.push($scope.setUpChartData(entry));
      return ladderGroupChartDataList;
    }, []);
  }
  function getLadderGroupChartDataAfterFilter(filteredData) {
    return _.reduce(filteredData, function (ladderGroupChartDataList, entry) {
      currencyCode = entry.groupedRows[0].currencyCode;
      ladderGroupChartDataList.push($scope.setUpChartData(entry));
      return ladderGroupChartDataList;
    }, []);
  }
  function getEntryTitle(entry, isCompetitor) {
    var prefix = isCompetitor ? entry.carrier + ': ' : 'HOST: ';
    return prefix + entry.fbc;
  }
  function mapLabels(sourceItem, labelFields) {
    return _.map(labelFields, function (groupingItem) {
      var value = !_.isNil(sourceItem[groupingItem.field]) ? sourceItem[groupingItem.field] : '';
      if (groupingItem.field === 'currencyCode') {
        value = currencyCode;
      }
      return groupingItem.field === 'season' ? value + ' ' + groupingItem.label : groupingItem.label + ' ' + value;
    });
  }
  $scope.setUpChartData = function (entry, isCompetitor) {
    if (!_.isEmpty(entry)) {
      return {
        title: getEntryTitle(entry, isCompetitor),
        data: convertEffectiveAndDiscDate(entry),
        labels: mapLabels(entry, applicableDateLabels)
      };
    }
  };
  var convertEffectiveAndDiscDate = function convertEffectiveAndDiscDate(entry) {
    entry.effectiveDate = entry.effectiveDate && typeof entry.effectiveDate === 'string' ? entry.effectiveDate : entry.effectiveDate.format('YYYY-MM-DD');
    if (entry.discontinueDate !== undefined) {
      entry.discontinueDate = entry.discontinueDate && typeof entry.discontinueDate === 'string' ? entry.discontinueDate : entry.discontinueDate.format('YYYY-MM-DD');
    }
    return entry;
  };
  $scope.$on('hostViewFilter', function () {
    var filters = $scope.screenState.detailsFilters;
    var contextData = $scope.screenState.recommendationDetailsPanel.contextData;
    var toBeFilteredDate = getLadderGroupChartData(contextData);
    var pureLadderDataToBeFiltered = _.map(toBeFilteredDate, function (rawData) {
      return rawData.data;
    });
    var filteredData = recommendationFilterService.filterRawData(pureLadderDataToBeFiltered, filters, 'detailsPanel');
    $scope.screenState.recommendationDetailsPanel.ladderGroupChartDataList = getLadderGroupChartDataAfterFilter(filteredData);
  });
  $scope.$emit('host_window_enable_panel');
};
HostLadderListController.$inject = ['$scope', 'RecommendationFilterService', 'FaresOptimizerMapHostLadderSelectedCompetitorService'];
module.exports = HostLadderListController;